module.exports = __webpack_public_path__ + "static/webmvideo-0fbf904984ab3bbc050e2112a924b266.webm";